import { LearningPortfolioNoteType } from './learning-portfolio.dto';
import { LearningPortfolioNoteValue } from './learning-portfolio.value';

interface CreateContextDto {
    pathwayId: string;
    courseId: string;
    moduleId: string;
    lessonId: string;
}

interface CreateTextPayloadDto {
    title: string;
    content: string;
}

interface CreateFilePayloadDto {
    title: string;
}

export class LearningPortfolioNoteValueDto {
    type: LearningPortfolioNoteType;
    payload: CreateTextPayloadDto | CreateFilePayloadDto;
    categoryIds: string[];
    attachmentIds: string[];
    context: CreateContextDto | null;

    constructor(value: LearningPortfolioNoteValue) {
        this.type = value.type;
        this.payload = value.type === 'text' ? { title: value.payload.title, content: value.payload.content } : { title: value.payload.title };
        this.categoryIds = value.categoryIds;
        this.attachmentIds = value.attachmentIds;
        this.context = value.context
            ? {
                  pathwayId: value.context.pathwayId,
                  courseId: value.context.courseId,
                  moduleId: value.context.moduleId,
                  lessonId: value.context.lessonId,
              }
            : null;
    }
}
